import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { notePanelRoute } from "@/features/panel-load-timing/utils/panelLoadTiming";

/**
 * Avisa a medição de carga (SA-1469) de cada troca de rota, para que um
 * desvio antes da lista (cadastro, onboarding, `/ativar-plano`) não seja
 * contado como carregamento. Não renderiza nada.
 */
export function PanelLoadRouteWatcher() {
  const { pathname } = useLocation();

  useEffect(() => {
    notePanelRoute(pathname);
  }, [pathname]);

  return null;
}
